export const pageSize = 20;
export const visibleTabs = 7;
